import axios from 'axios';

const ROOT = 'api/v1/finance/site-finance';

const SiteFinanceApi = {
  getSiteFinanceEvents(filters) {
    return axios.post(`${ROOT}`, filters);
  },
  exportSiteFinanceRevenueReport(filters) {
    return axios.post(`${ROOT}/revenue/export`, filters, { responseType: 'arraybuffer' });
  },
  exportSiteFinancePaymentDetailsReport(filters) {
    return axios.post(`${ROOT}/payment-details/export`, filters, { responseType: 'arraybuffer' });
  },
  getLifetimeAmounts(filters) {
    return axios.post(`${ROOT}/fin-overview`, filters);
  }
};

export default SiteFinanceApi;
